import { Component } from '@angular/core';
import { CoreSignalPublicationEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Publications') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-coresignalpublication-form',
    templateUrl: './coresignalpublication.form.component.html'
})
export class CoreSignalPublicationFormComponent extends BaseFormComponent {
    public record!: CoreSignalPublicationEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

